module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Regional-Landing-Page.1b7a3653.jpg";